import { Form, Input, Button, Row, Col } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PasswordValidator from 'password-validator';

const StyledDiv = styled.div`
  .login-form {
    max-width: 600px;
  }
  .login-form-forgot {
    float: right;
  }
  .ant-col-rtl .login-form-forgot {
    float: left;
  }
  .login-form-button {
    width: 100%;
  }
  .title {
    width: 67px;
    height: 36px;
    /* margin: 0 121px 33px 15px; */
    font-size: 24px;
    /* font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal; */
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
  }

  @media only screen and (min-width: 600px) {
    #first-row {
      margin-top: 300px;
    }
  }

  @media only screen and (max-width: 600px) {
    #first-row {
      margin-top: 30px;
    }
  }

  /* .content {
    width: 460px;
    height: 508px;
    padding: 40px 75px;
    background-color: #fff;
  } */
`;
interface LoginComponentProps {
  login: (data: any) => void;
}
function LoginComponent({ login }: LoginComponentProps) {
  const validatePassword = (value: string) => {
    const schema = new PasswordValidator();
    schema
      .is()
      .min(8)
      .is()
      .max(20)
      .has()
      .uppercase()
      .has()
      .lowercase()
      .has()
      .digits(1)
      .has()
      .not()
      .spaces();

    if (!value) {
      return Promise.reject(new Error('비밀번호는 필수 항목입니다.'));
    }

    if (!schema.validate(value)) {
      return Promise.reject(
        new Error(
          // '영문 대 소문자, 숫자, 특수문자를 조합한 8자 이상이어야 합니다.',
          '영문 대 소문자, 숫자를 조합한 8자 이상이어야 합니다.',
        ),
      );
    }
    return Promise.resolve();
  };

  return (
    <StyledDiv>
      <Row id="first-row" justify="center">
        <Col xs={20} md={6}>
          <img
            src={`${process.env.PUBLIC_URL}/img/higongsa_logo.png`}
            alt="higongsa_logo"
            style={{ width: '200px', paddingLeft: 0 }}
          />
        </Col>
      </Row>
      {/* <Row justify="center">
        <Col xs={20} md={6}>
          <Title level={2}>로그인</Title>
        </Col>
      </Row> */}
      {/* <Row>
        <Col flex={1}>
          <Divider />
        </Col>
      </Row> */}

      <Form
        name="normal_login"
        // className="login-form"
        layout={'vertical'}
        onFinish={login}
      >
        <Row justify="center">
          <Col xs={22} md={6}>
            <Form.Item
              name="email"
              label="이메일 계정"
              rules={[
                {
                  required: true,
                  message: '이메일을 입력 하세요.',
                },
                {
                  type: 'email',
                  message: '이메일 입력이 잘못 되었습니다.',
                },
              ]}
            >
              <Input
                prefix={
                  <UserOutlined
                    className="site-form-item-icon"
                    rev={undefined}
                  />
                }
                type="email"
                placeholder="이메일"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col xs={22} md={6}></Col>
        </Row>

        <Row justify="center">
          <Col xs={22} md={6}>
            <Form.Item
              name="password"
              label="비밀번호"
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
                {
                  validator: (_, value) => validatePassword(value),
                },
              ]}
            >
              <Input.Password
                prefix={
                  <LockOutlined
                    className="site-form-item-icon"
                    rev={undefined}
                  />
                }
                type="password"
                placeholder="비밀번호"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Col xs={22} md={6}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                로그인
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row justify="center">
        <Link to="auth/forgot-password" className="login-form-forgot">
          비밀번호를 잊으셨나요?
        </Link>
      </Row>

      {/* <Row justify="center" align="middle">
        <Col span={8}>
          <Row justify="center">
            <Col flex={1}>
              <Row justify="center">
                <span className="title">로그인</span>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col flex={1}>
              <Divider />
            </Col>
          </Row>
          <Form
            name="normal_login"
            className="login-form"
            layout={'vertical'}
            onFinish={login}
          >
            <Form.Item
              name="email"
              label="이메일 계정"
              rules={[
                {
                  required: true,
                  message: '이메일을 입력 하세요.',
                },
                {
                  type: 'email',
                  message: '이메일 입력이 잘못 되었습니다.',
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                type="email"
                placeholder="이메일"
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="비밀번호"
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
                {
                  validator: (_, value) => validatePassword(value),
                },
              ]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="비밀번호"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                로그인
              </Button>
            </Form.Item>
          </Form>
          <Row justify="center">
            <Link to="auth/forgot-password" className="login-form-forgot">
              비밀번호를 잃어버리셨나요?
            </Link>
          </Row>
        </Col>
      </Row> */}
    </StyledDiv>
  );
}

export default LoginComponent;
